import { configureStore } from "@reduxjs/toolkit";
import organizationReducer from "../redux/slices/organizationSlice";
import certConnectReducer from "../redux/slices/certConnectSlice";
import designationReducer from "../redux/slices/designationSlice";
import modalReducer from "../redux/slices/modalSlice";
import countryReducer from "../redux/slices/countrySlice";
import stateReducer from "../redux/slices/stateSlice";

export const store = configureStore({
  reducer: {
    modals: modalReducer,
    organization: organizationReducer,
    certConnect: certConnectReducer,
    designation: designationReducer,
    country: countryReducer,
    state: stateReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }), // thunk included automatically
  devTools: process.env.NODE_ENV !== "production",
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
